import React from 'react'
import './styles.scss'

const glaciers = {
  'Lucendro': require('../main/img/lucendro.svg'),
  'Ofental': require('../main/img/ofental.svg'),
  'Mucia': require('../main/img/mucia.svg')
}

export default function glacier (props) {
  let lossArea = Math.round(props.l * 10) / 10
  let lossPercentage = Math.round(props.p * 10) / 10

  return (
    <div className='glacier-wrapper'>
      <div className='glacier-name'><span>{props.n}</span><div className='canton'>{props.k}</div></div>
      <div className='glacier-loss'>{lossArea}</div>
      <div className='glacier-percentage'>{lossPercentage} km&sup2;</div>
      <div className='glacier-shape'>
        <img src={glaciers[props.n]} alt='' className='ui fluid image' />
      </div>
    </div>
  )
}
